import Loadable from "react-loadable";
import LoadableLoader from "./LoadableLoader";
export default function InsiderLoadable(opts) {
    return Loadable(Object.assign({ loading: opts.customLoader ? opts.customLoader : LoadableLoader, delay: 200, timeout: 10000 }, opts));
}
